import { buildStripeCheckoutSuccessUrl } from './stripeCheckoutReturn'
import { getAbsoluteUrl } from './getAbsoluteUrl'

export interface PaymentMethodSetupReturnOptions {
  /** Relative path override. Defaults to the current page. */
  returnPath?: string
}

export const buildPaymentMethodSetupReturnUrls = (
  options?: PaymentMethodSetupReturnOptions
): { success_url: string; return_url: string; cancel_url: string } => {
  const base = options?.returnPath
    ? new URL(getAbsoluteUrl(options.returnPath))
    : new URL(window.location.href)

  return {
    success_url: buildStripeCheckoutSuccessUrl('payment_method_setup'),
    return_url: base.toString(),
    cancel_url: base.toString()
  }
}
